<template>
  <div class="table-view">
    <div class="row">
      

      <div class="col-12" v-show="logs.length">
        <table
          id="searchResultsTable"
          class="table dt-responsive"
          cellspacing="0"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>Time</th>
              <th>Level</th>
              <th>Plugin:Action:Menu</th>
              <th>Message</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import baseUrl from "@/shared/baseUrl";
import { useToast } from "vue-toastification";
import api from "@/shared/menuApi";

export default {
  name: 'ActionLogTableView',
  props: {
    appId: {
      type: String,
      required: true
    },
    logs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      searchFilter: {
        appId: '',
        filterByMenu: false,
        filterByLevel: false,
        filterByPlugin: false,
        level: "",
        menuId: "",
        plugin: "",
      },
      menusList: [],
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  watch: {
    appId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          console.log('AppId changed, updating search filter:', newVal);
          this.searchFilter.appId = newVal;
          this.getMenusLite();
        }
      }
    },
    logs: {
      handler(newLogs) {
        if (newLogs && newLogs.length) {
          console.log('New logs received, rendering table:', newLogs.length);
          this.renderDataTable(newLogs);
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * Fetches the list of menus for the current application
     */
    async getMenusLite() {
      try {
        console.log('Fetching menus for table view:', this.appId);
        this.menusList = await api.getAllMenusLite(this.appId);
        console.log('Menus fetched successfully:', this.menusList.length);
      } catch (error) {
        console.error('Error fetching menus:', error);
        this.toast.error('Failed to fetch menus');
      }
    },

    /**
     * Renders the DataTable with the provided log data
     * @param {Array} rows - Array of log entries to display
     */
    async renderDataTable(rows) {
      console.log('Rendering data table with rows:', rows.length);
      let table = $("#searchResultsTable").DataTable({
        destroy: true,
        paging: true,
        dom: "Bfrtip",
        buttons: ["copy", "csv"],
        data: rows,
        columns: [
          { data: "time" },
          { data: "logLevel" },
          { data: "pluginActionMenu" },
          { data: "message" },
          {
            className: "showRowDetails",
            orderable: false,
            data: null,
            defaultContent: `<button type="button" class="btn btn-primary btn-rounded btn-icon text-white showRowDetails"><i class="fa fa-plus"></i></button>`,
          },
        ],
        responsive: true,
        order: [[1, "asc"]],
      });

      // Setup click handler for details button
      let vm = this;
      $("#searchResultsTable tbody").on(
        "click",
        "td.showRowDetails",
        function () {
          var tr = $(this).closest("tr");
          var row = table.row(tr);
          if (row.child.isShown()) {
            row.child.hide();
            tr.removeClass("shown");
            $(this).find('i').removeClass('fa-minus').addClass('fa-plus');
          } else {
            row.child(vm.getDetailsRow(row.data())).show();
            tr.addClass("shown");
            $(this).find('i').removeClass('fa-plus').addClass('fa-minus');
          }
        }
      );
    },

    /**
     * Generates the HTML for the details row
     * @param {Object} data - The log entry data
     * @returns {string} HTML string for the details row
     */
    getDetailsRow(data) {
      if (!data || !data.data) {
        console.log('No details available for log entry');
        return `
          <div class="details-container">
            <div class="details-header">
              <span class="details-title">Details</span>
            </div>
            <div class="details-content">
              <pre class="details-pre"><code class="details-code">No additional details available</code></pre>
            </div>
          </div>
        `;
      }

      // Try to parse the data if it's JSON
      let formattedData = data.data;
      try {
        if (typeof data.data === 'string') {
          console.log('Parsing string data as JSON');
          const parsed = JSON.parse(data.data);
          formattedData = JSON.stringify(parsed, null, 2);
        } else if (typeof data.data === 'object') {
          console.log('Formatting object data');
          formattedData = JSON.stringify(data.data, null, 2);
        }
      } catch (e) {
        console.warn('Failed to parse data, using original format:', e);
        formattedData = data.data;
      }

      return `
        <div class="details-container">
          <div class="details-header">
            <span class="details-title">Details</span>
          </div>
          <div class="details-content">
            <pre class="details-pre"><code class="details-code">${formattedData}</code></pre>
          </div>
        </div>
      `;
    },
  },
};
</script>

<style lang="css" scoped>
select,
select:focus {
  color: rgb(15, 8, 8);
}
select:disabled {
  color: rgb(171, 169, 169);
}
#searchResultsTable.table td {
  vertical-align: middle;
  line-height: 1;
  white-space: nowrap;
  padding: 0.25rem 0.2375rem !important;
}

.dataTables_wrapper .dataTable .btn {
  padding: 0.1rem 0rem;
  vertical-align: top;
}

.btn.btn-icon {
  width: 38px;
  height: 38px;
}

/* Details styling - Dark Theme */
:deep(.details-container) {
  background: #1e1e1e;
  border: 1px solid #333;
  border-radius: 4px;
  margin: 10px;
  overflow: hidden;
}

:deep(.details-header) {
  background: #2d2d2d;
  padding: 8px 15px;
  border-bottom: 1px solid #333;
}

:deep(.details-title) {
  font-weight: 600;
  color: #e0e0e0;
}

:deep(.details-content) {
  padding: 15px;
  max-height: 400px;
  overflow-y: auto;
  background: #1e1e1e;
}

:deep(.details-pre) {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  background: #1e1e1e;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #333;
}

:deep(.details-code) {
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.9em;
  color: #d4d4d4;
  line-height: 1.5;
}

/* Dark theme syntax highlighting */
:deep(.details-code) {
  color: #d4d4d4;
}

:deep(.details-code .string) { color: #ce9178; }
:deep(.details-code .number) { color: #b5cea8; }
:deep(.details-code .boolean) { color: #569cd6; }
:deep(.details-code .null) { color: #808080; }
:deep(.details-code .key) { color: #9cdcfe; }

/* Scrollbar styling for dark theme */
:deep(.details-content::-webkit-scrollbar) {
  width: 8px;
  height: 8px;
}

:deep(.details-content::-webkit-scrollbar-track) {
  background: #1e1e1e;
}

:deep(.details-content::-webkit-scrollbar-thumb) {
  background: #424242;
  border-radius: 4px;
}

:deep(.details-content::-webkit-scrollbar-thumb:hover) {
  background: #4f4f4f;
}
</style> 